import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../services/api';

// "Needs Attention" card pinned above the therapist dashboard widgets:
// clients who turned 18 while still marked minor, clients whose portal
// consent paperwork is over a year old, and birthdays in the next 7 days.
// All computed live — items disappear when the underlying data is fixed.

function fmtDate(d) {
  if (!d) return '';
  const dt = new Date(d);
  return isNaN(dt) ? '' : dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
function fmtUpcoming(d) {
  if (!d) return '';
  const dt = new Date(d);
  if (isNaN(dt)) return '';
  const today = new Date();
  const isToday = dt.toDateString() === today.toDateString();
  return isToday ? 'today 🎉' : dt.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
}

export default function ClientAttentionCard() {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    API.get('/therapist/client-attention')
      .then((res) => { if (active) setData(res.data); })
      .catch(() => { /* non-fatal */ });
    return () => { active = false; };
  }, []);

  if (!data) return null;
  const { turned18 = [], staleConsent = [], birthdays = [] } = data;
  if (turned18.length === 0 && staleConsent.length === 0 && birthdays.length === 0) return null;

  const openProfile = (id) => navigate(`/therapist/client-profile?clientId=${id}`);

  return (
    <div style={cardStyle}>
      <h3 style={{ margin: '0 0 2px', fontSize: 17 }}>Client attention</h3>
      <div style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 10 }}>
        These clear on their own once the client's profile or paperwork is updated.
      </div>

      {turned18.map((c) => (
        <div key={`a-${c.id}`} style={{ ...rowStyle, background: '#fde8e8', border: '1px solid #f5c2c2' }}>
          <div style={{ flex: 1 }}>
            🔞 <strong>{c.client_name}</strong> is now 18 but still marked as a minor —
            update signatures and ROI if needed, then un-check "Is minor" on their profile.
          </div>
          <button style={btnStyle} onClick={() => openProfile(c.id)}>Open profile</button>
        </div>
      ))}

      {staleConsent.map((c) => (
        <div key={`s-${c.id}`} style={{ ...rowStyle, background: '#fff3cd', border: '1px solid #ffe69c' }}>
          <div style={{ flex: 1 }}>
            📄 <strong>{c.client_name}</strong>'s consent paperwork is over a year old
            (last signed {fmtDate(c.last_consent)}) — send a new intake link to refresh it.
          </div>
          <button style={btnStyle} onClick={() => openProfile(c.id)}>Open profile</button>
        </div>
      ))}

      {birthdays.map((c) => (
        <div key={`b-${c.id}`} style={{ ...rowStyle, background: '#e7f6ec', border: '1px solid #bfe5cc' }}>
          <div style={{ flex: 1 }}>
            🎂 <strong>{c.client_name}</strong> has a birthday {fmtUpcoming(c.upcoming)}
            {c.turns ? ` — turning ${c.turns}` : ''}.
          </div>
        </div>
      ))}
    </div>
  );
}

const cardStyle = {
  background: 'var(--white)', border: '1px solid var(--border-color)',
  borderRadius: 12, padding: '14px 18px', marginBottom: 20,
  boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
};
const rowStyle = {
  display: 'flex', gap: 12, alignItems: 'center',
  borderRadius: 8, padding: '8px 12px', margin: '6px 0', fontSize: 14,
};
const btnStyle = {
  flexShrink: 0, background: 'var(--primary-color)', color: '#fff', border: 'none',
  borderRadius: 6, padding: '6px 12px', fontWeight: 700, fontSize: 12.5, cursor: 'pointer',
};
